/**
 * Online Order Form DB Service REST API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { BeltCircumferenceRange } from './beltCircumferenceRange';
import { BeltCircumference } from './beltCircumference';


export interface OofBeltDto { 
    length?: number;
    color?: string;
    thickness?: OofBeltDto.ThicknessEnum;
    edge?: OofBeltDto.EdgeEnum;
    shape?: OofBeltDto.ShapeEnum;
    width?: number;
    labelPlate?: string;
    paintedLabel?: string;
    cottonLayer?: number;
    protective?: boolean;
    reflectiveStripe?: boolean;
    minimalLength?: number;
    maximalLength?: number;
    punchingScrewSize?: string;
    punchingSpace?: number;
    quickRelease?: boolean;
    solar?: boolean;
    elasticBeltType?: OofBeltDto.ElasticBeltTypeEnum;
    growingBeltType?: OofBeltDto.GrowingBeltTypeEnum;
    labelPlateWithFrequency?: boolean;
    labelPlateWithId?: boolean;
    circumference?: BeltCircumference;
    circumferenceRange?: BeltCircumferenceRange;
    beltSizeCode?: OofBeltDto.BeltSizeCodeEnum;
}
export namespace OofBeltDto {
    export const ThicknessEnum = {
        StSt: 'ST_ST',
        SfSf: 'SF_SF',
        StSf: 'ST_SF',
        SolarBelt: 'SOLAR_BELT',
        StStStSt: 'ST_ST_ST_ST',
        ElasticBand: 'ELASTIC_BAND'
    } as const;
    export type ThicknessEnum = typeof ThicknessEnum[keyof typeof ThicknessEnum];
    export const EdgeEnum = {
        Rounded: 'rounded',
        Smooth: 'smooth'
    } as const;
    export type EdgeEnum = typeof EdgeEnum[keyof typeof EdgeEnum];
    export const ShapeEnum = {
        Oval: 'oval',
        Round: 'round',
        OvalRound: 'oval-round',
        DropShaped: 'drop-shaped'
    } as const;
    export type ShapeEnum = typeof ShapeEnum[keyof typeof ShapeEnum];
    export const ElasticBeltTypeEnum = {
        Type1: 'type 1',
        Type2: 'type 2',
        ElasticMooseCollar: 'elastic moose collar'
    } as const;
    export type ElasticBeltTypeEnum = typeof ElasticBeltTypeEnum[keyof typeof ElasticBeltTypeEnum];
    export const GrowingBeltTypeEnum = {
        G1: 'G-1'
    } as const;
    export type GrowingBeltTypeEnum = typeof GrowingBeltTypeEnum[keyof typeof GrowingBeltTypeEnum];
    export const BeltSizeCodeEnum = {
        S: 'S',
        M: 'M',
        L: 'L',
        Xl: 'XL',
        SML: 'S/M/L'
    } as const;
    export type BeltSizeCodeEnum = typeof BeltSizeCodeEnum[keyof typeof BeltSizeCodeEnum];
}


export type BeltSizeCodeEnum = typeof OofBeltDto.BeltSizeCodeEnum[keyof typeof OofBeltDto.BeltSizeCodeEnum];
